import { remove } from 'ramda';

import * as types from '../constants/ActionTypes';

export const initialState = {
    cancelModalOpen: false,
    deleteModalOpen: false,
    firsttimeopened: true,
    homeworkDescription: '',
    homeworkExercises: [],
    homeworkId: null,
    homeworkTitle: '',
    inputError: false,
    message: "Attenzione: l'esercizio richiesto potrebbe non essere aggiornato",
    homeworkUpdated: true,
    loaded: true
};

export default function HomeworkDetailReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.CHANGE_DETAIL_INPUT_STYLE: {
            return {
                ...state,
                inputError: true
            };
        }
        case types.CHANGE_HOMEWORK_DETAIL_TITLE:
            return {
                ...state,
                homeworkTitle: action.homeworkTitle,
                inputError: false
            };
        case types.CHANGE_HOMEWORK_DETAIL_DESCRIPTION:
            return {
                ...state,
                homeworkDescription: action.homeworkDescription
            };
        case types.GET_HOMEWORK: {
            return {
                ...state,
                homeworkId: null,
                message: null,
                loaded: false
            };
        }
        case types.GET_HOMEWORK_SUCCESS: {
            return {
                ...state,
                ...action.res,
                homeworkId: action.res.homeworkId,
                message: null,
                firsttimeopened: false,
                loaded: true
            };
        }
        case types.GET_HOMEWORK_FAILURE:
            return {
                ...state,
                message: 'Si sono verificati errori nel recupero della verifica',
                firsttimeopened: false,
                loaded: true
            };
        case types.CLOSE_DELETE_HOMEWORK_MODAL:
            return {
                ...state,
                deleteModalOpen: false
            };
        case types.OPEN_DELETE_HOMEWORK_MODAL:
            return {
                ...state,
                deleteModalOpen: true
            };
        case types.DELETE_HOMEWORK_SUCCESS:
            return initialState;
        case types.DELETE_HOMEWORK_FAILURE:
            return {
                ...state,
                message: "Si sono verificati errori nell'eliminazione della verifica"
            };
        case types.ADD_EXERCISE_TO_HOMEWORK: {
            const elPos = state.homeworkExercises.findIndex(item => item.id === action.exercise.id);
            if (elPos === -1) {
                return {
                    ...state,
                    homeworkExercises: state.homeworkExercises.concat(action.exercise)
                };
            }
            return state;
        }
        case types.REMOVE_EXERCISE_FROM_HOMEWORK: {
            const elPos = state.homeworkExercises.findIndex(item => item.id === action.exerciseId);
            return {
                ...state,
                ...(elPos >= 0 && { homeworkExercises: remove(elPos, 1, state.homeworkExercises) })
            };
        }
        case types.ADD_EXERCISES_TO_HOMEWORK: {
            const { exercisesToAdd } = action;
            exercisesToAdd.forEach(exercise => {
                if (!state.homeworkExercises.find(item => item.id === exercise.id)) {
                    state.homeworkExercises.push(exercise);
                }
            });
            return {
                ...state,
                homeworkExercises: state.homeworkExercises
            };
        }
        case types.UPDATE_HOMEWORK:
            return {
                ...state,
                homeworkUpdated: false
            };
        case types.UPDATE_HOMEWORK_SUCCESS:
            return {
                ...state,
                homeworkUpdated: true
            };
        case types.UPDATE_HOMEWORK_FAILURE:
            return {
                ...state,
                message: 'Si è verificato un errore durante il salvataggio della verifica',
                homeworkUpdated: true
            };
        case types.REORDER_HOMEWORK_EXERCISES:
            return {
                ...state,
                homeworkExercises: action.exercises.map(item => ({
                    ...item,
                    isPreviewOpen: false
                }))
            };
        case types.UPDATE_LOCATION: {
            const path = window.location.pathname;
            const addItemIdx = path.indexOf('additem');
            if (addItemIdx >= 0) {
                //attivo il messaggio di alert perchè vorrei aggiungere un esercizio
            }
            const myLibraryIdx = path.indexOf('myLibrary');
            const homeworkDetailIdx = path.indexOf('homeworkDetail');
            return {
                ...state,
                ...(myLibraryIdx >= 0 && { message: initialState.message }),
                ...(homeworkDetailIdx >= 0 && { message: '' }),
                ...(homeworkDetailIdx >= 0 && state.firsttimeopened && { firsttimeopened: false })
            };
        }
        case types.CLOSE_CANCEL_HOMEWORK_MODAL:
            return {
                ...state,
                cancelModalOpen: false
            };
        case types.OPEN_CANCEL_HOMEWORK_MODAL:
            return {
                ...state,
                cancelModalOpen: true
            };
        default:
            return state;
    }
}
